import type { AccountSetting } from '@/services/auth/account-settings';
import { useAccountSetting } from '@/services/auth/account-settings';
import { renderGuardFallback, type GuardFallback } from './guard-fallback';

/**
 * Renders children only when the given account setting (`accounts.public_settings`) is on. Falls back
 * to the given {@link GuardFallback}, or renders nothing by default. Subscribes to the account store,
 * so guarded content reacts to setting changes within a session. The account-setting analogue of
 * {@link FeatureFlagGuard}.
 */

type AccountSettingGuardProps = {
  setting: AccountSetting;
  fallback?: GuardFallback;
  children: React.ReactNode;
};

export function AccountSettingGuard({ setting, fallback, children }: AccountSettingGuardProps) {
  const enabled = useAccountSetting(setting);

  if (!enabled) {
    return <>{renderGuardFallback(fallback)}</>;
  }

  return <>{children}</>;
}
